import type { ColorName } from 'styles/config/colors';

import { colorCssVar } from 'utils/colorCssVar';

export const LogoText = ({
  textColor: textColorName = 'textPrimaryInverse',
  width = 54,
  height = 24,
  className,
}: {
  textColor?: ColorName;
  width?: number;
  height?: number;
  className?: string;
}) => {
  const textColor = colorCssVar(textColorName ?? 'textPrimaryInverse');

  return (
    <svg
      className={className}
      fill="none"
      height={height}
      viewBox="0 0 52 22"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M52 6.468V5.03h-5.014v1.438h1.633v8.123a1.24 1.24 0 0 1-1.242 1.236h-.394v1.436h5.014v-1.436h-1.633V6.468H52ZM20.14 17.263v-1.365h.26a1.29 1.29 0 0 0 1.292-1.286V6.384h-1.374V5.019h3.034v10.882h1.552v1.364h-4.76l-.003-.002Zm25.598 0h-1.975l-1.147-3.237h-5.432l-1.163 3.237h-1.905l4.638-12.246h2.435l4.549 12.246Zm-6.772-8.17-1.2 3.323h4.269l-1.182-3.323a80.565 80.565 0 0 0-.936-2.625c-.193.508-.475 1.33-.951 2.625ZM.705 17.265V5.02h5.01c2.608 0 4.11 1.523 4.11 3.726 0 2.204-1.518 3.745-4.127 3.745H2.471v4.775H.705ZM2.468 6.63v4.338h2.91c1.73 0 2.594-.944 2.594-2.222S7.142 6.63 5.379 6.63h-2.91Zm12.233 2.029c-2.365 0-4.282 1.98-4.282 4.425 0 2.446 1.917 4.426 4.282 4.426 2.366 0 4.282-1.98 4.282-4.426 0-2.443-1.916-4.425-4.282-4.425Zm0 7.139c-1.45 0-2.627-1.215-2.627-2.714 0-1.499 1.176-2.714 2.627-2.714 1.452 0 2.628 1.215 2.628 2.714 0 1.5-1.177 2.714-2.628 2.714ZM32.3 8.588l-1.5 4.496c-.404 1.173-.51 1.504-.671 1.978-.159-.421-.317-.805-.899-2.151l-1.8-4.32h-1.853l3.862 8.572-.442 1.241c-.245.665-.6.805-1.2.805h-1.123l-.64 1.42v.047h1.816c1.533 0 2.186-.542 2.752-2.185l3.439-9.9h-1.748l.006-.003Z"
        fill={textColor}
      />
    </svg>
  );
};

export default LogoText;
